import type { QueryHookOptions } from "@apollo/client";
import { useLazyQuery, useQuery, gql } from "@apollo/client";

import type { MapAgreement } from "@clinic/shared/data/splinters/MapAgreement.fragment";
import { MAP_AGREEMENT } from "@clinic/shared/data/splinters/MapAgreement.fragment";

const MapAgreementById_ClinicShared_Query = gql`
  query MapAgreementById_ClinicShared_Query($mapId: ID!) {
    viewer {
      mapAgreements: node(id: $mapId) {
        ... on MapAgreement {
          ...MapAgreement
        }
      }
    }
  }
  ${MAP_AGREEMENT}
`;

interface MapAgreementData {
  viewer: {
    mapAgreements: MapAgreement;
  };
}

interface Variables {
  mapId: string;
}

const useMapAgreementByIdQuery = (options?: QueryHookOptions<MapAgreementData, Variables>) => {
  return useQuery<MapAgreementData, Variables>(MapAgreementById_ClinicShared_Query, options);
};

const useMapAgreementByIdQueryLazyQuery = (
  options?: QueryHookOptions<MapAgreementData, Variables>
) => useLazyQuery<MapAgreementData, Variables>(MapAgreementById_ClinicShared_Query, options);

export type { MapAgreementData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  useMapAgreementByIdQuery,
  useMapAgreementByIdQueryLazyQuery,
  MapAgreementById_ClinicShared_Query,
};
